module.exports = __webpack_public_path__ + "img/about_41.1dcd0c5c.jpg";